import type { ColDef } from "ag-grid-enterprise";

// Compact Clear-only footer for filter popups (styled in eb_theme.ts).
// No Apply/Reset/Cancel — filters apply as you type; Reset was redundant.
export const ebFilterParams: NonNullable<ColDef["filterParams"]> = {
  buttons: ["clear"],
};

// Renames the Clear button's label; merge into each grid's GridOptions.localeText.
export const ebLocaleText: Record<string, string> = {
  clearFilter: "Clear Filter",
};
